function closeKrVideoLightbox(modal) {
  if (!modal) return;

  const video = modal.querySelector('video');

  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  modal.hidden = true;
  document.body.classList.remove('kr-video-lightbox-is-open');
}

document.addEventListener('click', function (event) {
  const openButton = event.target.closest('[data-kr-video-open]');
  const closeButton = event.target.closest('[data-kr-video-close]');

  if (openButton) {
    const block = openButton.closest('[data-kr-video-lightbox]');
    const modal = block?.querySelector('[data-kr-video-modal]') || document.querySelector('[data-kr-video-modal]');
    const video = modal?.querySelector('video');

    if (!modal) return;

    document.body.appendChild(modal);

    modal.hidden = false;
    document.body.classList.add('kr-video-lightbox-is-open');

    if (video) {
      video.play().catch(() => {});
    }
  }

  if (closeButton) {
    const modal = closeButton.closest('[data-kr-video-modal]');
    closeKrVideoLightbox(modal);
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document
    .querySelectorAll('[data-kr-video-modal]:not([hidden])')
    .forEach(closeKrVideoLightbox);
});